import styled from 'styled-components';

export const AlertOverlay = styled.section(
  props => `
    background: rgba(0,0,0,0.5);
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
  `,
);

export const AlertPopup = styled.section`
  background: white;
  border-radius: 1.6rem;
  width: ${props => props.width};
`;
export const AlertHeader = styled.header(
  props => `
    padding: 2rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #eef4fd;
`,
);
export const HeaderTxt = styled.span(
  props => `
        font-size: 2.2rem;
        color: #141823;
        text-transform: uppercase;
        font-weight: bold;
        font-family:${props.theme.font.fontFamily};
        padding-left: 1rem;
    `,
);

export const HeaderTxtWrap = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const AlertContent = styled.div`
  padding: 2rem;
  min-height: 12rem;
`;
export const AlertFooter = styled.div`
  display: flex;
  align-self: flex-end;
  padding: 2rem;
  display: flex;
  flex-direction: row;
`;
export const FooterBtn = styled.button`
  border: 0;
  outline: 0;
  color: white;
  font-size: 1.6rem;
  font-weight: bold;
  text-transform: uppercase;
  text-align: center;
  background: #ff6d38;
  border-radius: 0.4rem;
  padding: 1rem;
  flex: 1;
  cursor:pointer;
`;
export const ContentTxt = styled.p`
  font-size: 1.6rem;
  line-height: 1.2;
  color: #141823;
`;
